export const URL = 'https://us-central1-js-capstone-backend.cloudfunctions.net/api';
export const APIkey = 'YqXfXTjDxbNNYGuuh7h9';
